import React from "react";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import * as moment from "moment";
import DOMPurify from "dompurify";

import { useNavigate } from "react-router-dom";

const ViewContractorDuplicate: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, selectedRecord }) => {
  const navigate = useNavigate();

  return (
    <Modal
      id="showModal"
      size="xl"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-primary-subtle p-3" toggle={toggle}>
        View Contractor Duplicate
      </ModalHeader>

      <ModalBody>
        <Row className="mt-3 mb-4">
          <Col sm={6}>
            <h6 className="text-muted text-uppercase fw-semibold mb-3">
              First Contractor Details
            </h6>

            <div
              className="table-responsive border border-dashed rounded p-2  mb-3"
              // style={{ minHeight: "200px" }}
            >
              <table className="table table-md table-borderless table-striped mb-0">
                <tbody>
                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Contractor Name:
                    </td>
                    <td>
                      <p className="fw-medium mb-0 fs-14" id="billing-name">
                        {`${selectedRecord?.contractorA?.contractorName}` ||
                          "Not Provided"}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Organization Type:
                    </td>
                    <td>
                      {selectedRecord?.contractorA?.organizationType?.name ||
                        "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">Acronym:</td>
                    <td>
                      {selectedRecord?.contractorA?.acronym || "Not Provided"}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Previous or Alias Name:
                    </td>
                    <td>
                      {selectedRecord?.contractorA?.previousOrAliasName
                        ?.map((name: any) => name.name)
                        .join(", ") || "Not Provided"}
                    </td>
                  </tr>

                  <tr>
                    <td className="fw-medium text-muted">SEMGMentions:</td>
                    <td>
                      {selectedRecord?.contractorA?.semgMentions?.count || "0"}
                    </td>
                  </tr>

                  <tr>
                    <td className="fw-medium text-muted">
                      Performance Ratings:
                    </td>
                    <td>
                      {selectedRecord?.contractorA?.performanceRatings?.some(
                        (rating: any) =>
                          rating.isActive &&
                          (rating.performanceRatingType.isFlag ||
                            rating.performanceRatingType.isDebarred)
                      )
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Contracts:
                    </td>
                    <td>
                      {selectedRecord?.contractorA?.contracts?.count || "0"}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Assessments:
                    </td>
                    <td>
                      {selectedRecord?.contractorA?.capacityAssessments?.count +
                        selectedRecord?.contractorA?.riskAssessments?.count +
                        selectedRecord?.contractorA?.pvrs?.count || "0"}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Last Updated:
                    </td>
                    <td>
                      {moment(
                        new Date(selectedRecord?.contractorA?.updatedAt)
                      ).format("DD MMM Y") || "Not Provided"}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Created At:
                    </td>
                    <td>
                      {moment(
                        new Date(selectedRecord?.contractorA?.createdAt)
                      ).format("DD MMM Y") || "Not Provided"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Col>
          <Col sm={6}>
            <h6 className="text-muted text-uppercase fw-semibold mb-3">
              Duplicate Contractor Details
            </h6>

            <div className="table-responsive border border-dashed rounded p-2  mb-3 ">
              <table className="table table-md table-borderless table-striped mb-0">
                <tbody>
                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "30%" }}
                    >
                      {" "}
                      Contractor Name:
                    </td>
                    <td>
                      {`${selectedRecord?.contractorB?.contractorName}` ||
                        "Not Provided"}
                    </td>
                  </tr>

                  <tr>
                    <td className="fw-medium text-muted">Organization Type:</td>
                    <td>
                      {selectedRecord?.contractorB?.organizationType?.name ||
                        "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">Acronym:</td>
                    <td>
                      {selectedRecord?.contractorB?.acronym ||
                        selectedRecord?.contractorB?.contactPersons?.[0]?.person
                          ?.fullName ||
                        "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">
                      Previous or Alias Name:
                    </td>
                    <td>
                      {selectedRecord?.contractorB?.previousOrAliasName
                        ?.map((name: any) => name.name)
                        .join(", ") || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">SEMGMentions:</td>
                    <td>
                      {selectedRecord?.contractorB?.semgMentions?.count || "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">
                      Performance Ratings:
                    </td>
                    <td>
                      {selectedRecord?.contractorB?.performanceRatings?.some(
                        (rating: any) =>
                          rating.isActive &&
                          (rating.performanceRatingType.isFlag ||
                            rating.performanceRatingType.isDebarred)
                      )
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">Contracts:</td>
                    <td>
                      {selectedRecord?.contractorB?.contracts?.count || "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">Assessments:</td>
                    <td>
                      {selectedRecord?.contractorB?.capacityAssessments?.count +
                        selectedRecord?.contractorB?.riskAssessments?.count +
                        selectedRecord?.contractorB?.pvrs?.count || "0"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">Last Updated:</td>
                    <td>
                      {moment(
                        new Date(selectedRecord?.contractorB?.updatedAt)
                      ).format("DD MMM Y") || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">Created At:</td>
                    <td>
                      {moment(
                        new Date(selectedRecord?.contractorB?.createdAt)
                      ).format("DD MMM Y") || "Not Provided"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-4">
            <h6 className="text-muted text-uppercase fw-semibold mb-3">
              Additional Information
            </h6>

            <div
              className="table-responsive border border-dashed rounded p-2  mb-3"
              // style={{ minHeight: "200px" }}
            >
              <table className="table table-md table-borderless table-striped mb-0">
                <tbody>
                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Has this duplicate contractor been resolved?
                    </td>
                    <td>
                      <p className="fw-medium mb-0 fs-14" id="billing-name">
                        {selectedRecord?.resolved ? (
                          <span className="badge bg-success-subtle text-success fs-12">
                            Yes
                          </span>
                        ) : (
                          <span className="badge bg-danger-subtle text-danger fs-12">
                            No
                          </span>
                        )}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="fw-medium text-muted"
                      style={{ whiteSpace: "nowrap", width: "25%" }}
                    >
                      Status - Is this a confirmed duplicate contractor?
                    </td>
                    <td>
                      {selectedRecord?.status === "duplicate" ? (
                        <span className="badge border border-warning text-warning fs-12">
                          Duplicate
                        </span>
                      ) : (
                        <span className="badge border border-success text-success fs-12">
                          Not Duplicate
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-medium text-muted">
                      Comments on resolution:
                    </td>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          selectedRecord?.reason || "Not Provided"
                        ),
                      }}
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </ModalBody>

      <div className="modal-footer d-flex justify-content-between">
        <div className="hstack gap-2"></div>
        <div className="hstack gap-2">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              toggle();
            }}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewContractorDuplicate;
